import React from "react";
//@ts-ignore
import { FileUpload } from "@careinfo/file-upload-service";
import SwitchTab from "../../components/Reusable/SwitchTab";
import { useParams } from "react-router-dom";
import Card from "../../components/Reusable/Card";
const MerchantFileUpload = () => {
  const { id } = useParams();
  return (
    <>
      <SwitchTab id={id} />
      <Card>
        <FileUpload object_id={id} />
      </Card>
    </>
  );
};

export default MerchantFileUpload;
